import React from "react";
import { withStyles, createStyles, WithStyles, Theme } from "@material-ui/core/styles";

import Button from "@material-ui/core/Button";
import Tooltip from "@material-ui/core/Tooltip";

import IconAdd from "@material-ui/icons/Add";

import { GridColumns } from "./companydetailsgridsetup";

import Confirmation from "../../lib/components/confirmation";
import Grid from "../../lib/components/grid";

import { companyDetailsBanking } from "../../lib/api/companydetailsbanking";
import { currency } from "../../lib/api/currency";

import EditFormBanking from "./companydetailseditformbanking";

import { SnackContext } from "../../lib/context/SnackContext";
import { GenerateErrorMessage } from "../../lib/helpers/string_methods";

const styles = (theme: Theme) =>
    createStyles({
        root: {
            padding: theme.spacing(1),
            width: "100%",
            height: "100%",
            position: "relative",
        },
        inline: {
            display: "inline",
            position: "absolute",
            marginTop: "7px",
            marginLeft: "7px",
        },
    });

type CompanyDetailsBankingProps = {} & WithStyles<typeof styles>;

class CompanyDetailsBankingUnstyled extends React.Component<CompanyDetailsBankingProps, any> {
    state = {
        classes: undefined,
        loading: false,
        companydetailsbanking: [],
        editRecord: undefined,
    };

    constructor(props) {
        super(props);
        this.state.classes = props.classes;
    }

    static contextType = SnackContext;
    context!: React.ContextType<typeof SnackContext>;

    componentDidMount() {
        this.getItem();
    }

    getItem = async () => {
        try {
            const [currencies, resultCompBanking] = await Promise.all([currency.all(), companyDetailsBanking.all()]);
            const resultCompBankingWithCurrency = resultCompBanking.map((item) => {
                const currencyfind = currencies.find((curr) => curr.id == item.currency_id);
                return { ...item, currency_code: currencyfind ? currencyfind.code : "ZAR" };
            });
            this.setState({
                companydetailsbanking: resultCompBankingWithCurrency.sort((a, b) => a.currency_code.localeCompare(b.currency_code)),
            });
        } catch (error) {
            const err = GenerateErrorMessage(error, "Error getting data");
            this.context.updateSnack({ show: true, color: "red", message: err });
        }
    };

    handleRemove = (id) => {
        companyDetailsBanking.remove(id).then(() => {
            this.getItem();
        });
    };

    handleEdit = (id) => {
        this.setState({ editRecord: id });
    };

    handleEditConfirm = () => {
        this.setState({ editRecord: undefined }, () => {
            this.getItem();
        });
    };

    GridColumnsOverride = (column, row) => {
        return GridColumns(column, row, this.handleRemove, this.handleEdit);
    };

    render() {
        const { classes } = this.state;
        return (
            <div className={classes.root}>
                <div className={classes.inline}>
                    <Tooltip title="Add Banking Details">
                        <div className={classes.inline}>
                            <Button variant="contained" color="primary" onClick={() => this.setState({ editRecord: "0" })} style={{ marginBottom: "10px" }}>
                                <IconAdd />
                            </Button>
                        </div>
                    </Tooltip>
                </div>
                <Grid loading={this.state.loading} data={this.state.companydetailsbanking} GridColumns={this.GridColumnsOverride} clearFilters={"companydetailsbanking"} />
                {this.state.editRecord && (
                    <Confirmation isOpen={true} handleClose={() => { }} handleConfirm={() => { }} title={"Banking Details"} body={undefined}>
                        <EditFormBanking id={this.state.editRecord} confirm={this.handleEditConfirm} />
                    </Confirmation>
                )}
            </div>
        );
    }
}

export default withStyles(styles)(CompanyDetailsBankingUnstyled);